import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import React from 'react';
import TestQuestion from '../components/testQuestion';
import { useGlobalContext } from '../context';
import Score from '../components/Score';
import Units from '../components/Units';
import { toast } from 'react-toastify';

const Test = () => {
  //const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const { setAnswerStates, lessonState, data, setData } = useGlobalContext();

  // console.log(lessonState);
  const navigate = useNavigate();
  let url;

  const nextQuestionHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAnswerStates(['normal', 'normal', 'normal', 'normal']);
    try {
      if (lessonState === 0) {
        url = 'https://jap-vocab-n2.herokuapp.com/api/v1/questions';
      } else {
        url = `https://jap-vocab-n2.herokuapp.com/api/v1/questions/${lessonState}`;
      }
      const questions = await axios.get(url);

      questions.data.randomAnswers = questions.data.randomAnswers.sort(
        (a, b) => 0.5 - Math.random()
      );

      setData(questions.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  // console.log(data.randomQuestion.indice);

  const goEngJap = () => {
    setData(null);
    navigate('/eng-jap');
  };

  return (
    <div
      className="flex main"
      style={{ flexDirection: 'column', paddingTop: '20px' }}
    >
      <section
        className="flex game-holder  "
        style={{ flexDirection: 'row', gap: '0.5rem' }}
      >
        <Units />
        <section
          className="flex game-holder"
          style={{
            flexDirection: 'column',

            alignItems: 'center',
          }}
        >
          <div
            className="flex"
            style={{
              flexDirection: 'row',
              justifyItems: 'stretch',
              gap: '1rem',
              flexWrap: 'wrap',
            }}
          >
            <Button
              variant="secondary"
              className="btn-100 go"
              onClick={goEngJap}
            >
              Eng-Jap
            </Button>

            <Button
              variant="secondary"
              className="btn-100 go"
              onClick={(e) => nextQuestionHandler(e)}
            >
              Go!
            </Button>
            <Score />
          </div>
          {loading && <div>LOADING...</div>}
          {data ? (
            <TestQuestion
              question={data.randomQuestion}
              answers={data.randomAnswers}
              engJap={false}
            />
          ) : (
            <div>CLICK GO TO START...</div>
          )}
        </section>
      </section>
    </div>
  );
};

export default Test;
